module.exports = __webpack_public_path__ + "img/Logo-Direct-Cor.980e2b2b.png";